import styled from 'styled-components';
import { gridSizes, media, weights } from 'utils/style';
import PaymentData from 'components/PaymentData/container';

export default styled(PaymentData)`
  .summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 32px;

    button {
      min-width: 30%;
      text-transform: uppercase;
    }
  }

  .error {
    color: var(--red-cherry-text);
  }

  .vat-value {
    font-size: ${gridSizes('M')};
    color: var(--grey900);
    font-weight: ${weights('regular')};
    margin: 0;
    text-align: right;

    .price {
      text-align: left;
      font-weight: ${weights('medium')};
      color: var(--grey900);
      font-size: 3.2rem;
    }

    ${media.lessThan('medium')`
    text-align: left;
  `};
  }

  .error {
    margin: ${gridSizes('M')} 0;
    font-size: ${gridSizes('M')};
    font-weight: 500;
    color: #cc000a;
  }
`;
